<div class="phrase-cat-match-container">
  <div class="phrase-cat-diff-container" style="position: relative;">
    <!-- Diff container -->
    <div class="text">
      <div *ngIf="catMatch.diffParts?.length > 0; else originalText">
        <span *ngIf="!showOriginal">
          <ng-container *ngIf="!useCharBasedPhraseDiff; else charBasedDiffs">
            <span *ngFor="let word of catMatch.diffParts" class="match-diff" [class.missing]="word.diffType == 'MISSING'"
              [class.extra]="word.diffType == 'EXTRA'">
              {{ word.text }}
            </span>
          </ng-container>
        </span>
        <span *ngIf="showOriginal">{{ catMatch.catPhrase.phraseText ?? catMatch.catTxt }}</span>
      </div>
      <ng-template #originalText>
        <span>{{ catMatch.catPhrase.phraseText ?? catMatch.catTxt }}</span>
      </ng-template>
      
      <ng-template #charBasedDiffs>
        <char-based-phrase-diffs [workingPhrase]="catMatch.phraseTxt" [matched]="catMatch.catPhrase.phraseText ?? catMatch.catTxt" >

        </char-based-phrase-diffs>
      </ng-template>
    </div>

    <div class="l-align-spaceBetween">
      <!--type-->
      <div style="text-align: left; margin-top: 5px" *ngIf="catMatch.anchors != null">
      <ng-container  *ngIf="catMatch.anchors == 'CONSISTENT'">
        <i
      class="fas fa-check"
      style="color: green"
      tooltip="{{ 'translate.consistencyIssues.consistentClaim' | translate }}"
    ></i>
      </ng-container>
    <ng-container *ngIf="catMatch.anchors == 'INCONSISTENT'">
        <i
      class="fas fa-times"
      style="color: red; font-size: 20px; margin-right: 5px"
      tooltip="{{'translate.consisteIssues.inconsistentClaim' | translate }}"
    ></i>
    </ng-container>
          <ai-icon></ai-icon>
          <a [class.disabled]="disableConsistencyCheckResultsActions" (click)="revertConsistencyCheckResult()" style="margin-left: 5px; text-decoration: none; cursor: pointer !important" class="fas fa-rotate-left" tooltip="{{'translate.general.revert' | translate}}"></a>
      </div>
      <div *ngIf="catMatch.catPhrase" class="cat-phrase-type">
        <span>
          {{ catMatch.catPhrase.typeDescr }}
          <span class="sub-type" *ngIf="catMatch.catPhrase.subTypeDescr">&middot; {{ catMatch.catPhrase.subTypeDescr
            }}</span>
        </span>
      </div>

      <p class="match-id">
        <span *ngIf="catMatch.catPhrase">
          {{ "translate.cat.phraseId" | translate }}:
          {{ catMatch.catPhrase.phraseId }}</span>
        &nbsp;
        <span *ngIf="displayPercentMatch">
        <strong>{{ "translate.cat.matchPercent" | translate }}: {{ catMatch[percentMatchPropName] * 100 | number: '1.0-0' }}%</strong>
        </span>
      </p>
    </div>
  </div>
  <div *ngIf="catMatch.diffParts?.length > 0">
    <div *ngIf="!showOriginal && catMatch.anchors != 'INCONSISTENT'">
      <button (click)="showOriginal = !showOriginal" class="eye-toggle"
        tooltip="{{ 'translate.rev.showOriginal' | translate }}">
        <i class="fas fa-eye"></i>
      </button>
    </div>
    <div *ngIf="showOriginal && catMatch.anchors != 'INCONSISTENT'">
      <button (click)="showOriginal = !showOriginal" class="eye-toggle"
        tooltip="{{ 'translate.rev.showDiff' | translate }}">
        <i class="fas fa-eye-slash"></i>
      </button>
    </div>
  </div>
</div>

<!--docs-->
<div *ngIf="
    (catMatch.catPhrase &&
    catMatch.catPhrase.docs &&
    catMatch.catPhrase.docs.length > 0)
  " class="docs-container t-small">
  <a (click)="displayDocsSw = !displayDocsSw">
    {{ "translate.cat.matchSourceDocs" | translate }}
    <span [ngClass]="!displayDocsSw ? 'pi pi-angle-down' : 'pi pi-angle-up'"></span>
  </a>
  <slide-in-out [isOpen]="displayDocsSw">
    <div class="docs-tbl">
      <cat-entry-docs *ngIf="catMatch.catPhrase" [docs]="catMatch.catPhrase.docs"></cat-entry-docs>
    </div>
  </slide-in-out>
</div>